// removed by extract-text-webpack-plugin
module.exports = {"not-found":"not-found__42064d7fc37d08a849a6ddae5634ee3c"};


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/errors/NotFound/style.scss
// module id = 1771
// module chunks = 55